import { useMemo } from "react";
import { GiftOffer, GiftOfferType, LineItemType, PurchaseRule } from "types";
import { GiftOfferLineItem, useCreatePurchaseStore } from "../../../stores/createPurchaseStore";
import { getTerms } from "../../Product/EditGiftOffer";
import { useResource } from "@/hooks/useResource";

export interface GiftFormValues {
    recipientEmail: string;
    recipientName: string;
    amount: number | null;
    message: string;
    sendToRecipient: boolean;
    code: string | null;
}

export const useCreatePurchaseGiftInitialValues = () => {
    const item = useCreatePurchaseStore((state) => state.getActiveItem());
    const product = useCreatePurchaseStore((state) => state.getActiveProduct<GiftOffer>());

    const purchaseRuleFromProduct = product?.purchaseRule;

    const { data: fetchedPurchaseRule } = useResource<PurchaseRule>(["purchaseRules", product?.purchaseRule?.id]);

    const giftPurchaseRule = purchaseRuleFromProduct?.actions ? purchaseRuleFromProduct : fetchedPurchaseRule;

    const isExperienceGift = "experience" in product;

    const giftTerms = getTerms(product, giftPurchaseRule);
    const isVariable = giftTerms.type === GiftOfferType.VARIABLE;
    const minimumPrice =
        isVariable && giftTerms.minimumPrice && giftTerms.minimumPrice > 0 ? giftTerms.minimumPrice : 1;
    const isChooseAnAmount = "baseGiftProduct" in product && product.baseGiftProduct && product.system;
    const isGiftAmount = isVariable || isChooseAnAmount;

    const initialValues: GiftFormValues | object = useMemo(() => {
        const giftAmountLineItem = item.lineItems.find((lineItem) => {
            return "type" in lineItem && lineItem.type === LineItemType.GIFT;
        }) as GiftOfferLineItem;

        const amount = isGiftAmount && !isExperienceGift ? giftAmountLineItem?.amount ?? minimumPrice : null;

        return {
            recipientEmail: item.recipientEmail,
            recipientName: item.recipientName,
            amount,
            message: item.message,
            sendToRecipient: item.sendToRecipient ?? false,
            code: item.code ?? null,
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- We want to recalculate this only on `item` change
    }, [item]);

    return initialValues;
};
